// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__wOwUI","fade-in":"Backdrop_fade-in__OLvVf","loader":"Backdrop_loader__3vS7h","spin":"Backdrop_spin__Z7qzQ","pop-up":"Backdrop_pop-up__vmnqK"};